import ClassNames from 'classnames';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext } from 'react';
import './styles.scss';
const Loading = () => {
  const { loading } = useContext(GlobalContext);

  const loadingClass = ClassNames({
    loading: true,
    'loading--visible': loading,
  });

  return (
    <div className={loadingClass}>
      <div className="loading__ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
